var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"finance-bill-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"container"},[(_vm.$slots.header)?_c('div',{staticClass:"slot-header"},[_vm._t("header")],2):_vm._e(),_vm._t("default"),(_vm.$slots.footer)?_c('div',{staticClass:"slot-footer"},[_vm._t("footer")],2):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }